import { OrgBaseInterface } from "../Shared/OrgBase.Interace";

export enum PaymentSessionStatus {
  CREATED = "created",
  OPENED = "opened",
  FAILED = "failed",
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  CANCELLED = "cancelled",
  EXPIRED = "expired",
}

export enum PaymentSessionMode {
  LIVE = "live",
  TEST = "test",
}

export interface PaymentSessionInterface extends OrgBaseInterface {
  sessionId: string;
  nonceHash: string;
  status: PaymentSessionStatus;
  mode: PaymentSessionMode;
  expiresAt: Date;
  openedAt: Date | null;
  completedAt?: Date | null;
  locationId: number;
  tenantId: number;
  paymentLink?: string | null;
  providerResult?: Record<string, any> | null;
}

export interface GetPaymentLinkPayload {
  orgId: number;
  locationId: number;
  tenantId: number;
  expirationInMinutes?: number;
  mode?: PaymentSessionMode;
}

export interface OpenPaymentSessionPayload {
  sessionId: string;
  token: string;
}
